<template>
  <div class="orderGoods">
    <div class="total">共{{ cartInfo.length }}件商品</div>
    <div class="goodWrapper">
      <div class="item acea-row row-between-wrapper" v-for="cart in cartInfo" :key="cart.id">
        <div class="pictrue">
          <img v-lazy="cart.productInfo.image" alt="img" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">
              <span v-if="cart.productInfo.productPresellAttr" class="event_name event_bg">预售</span>
              {{ cart.productInfo.store_name }}
            </div>
            <div class="num">x {{ cart.cart_num }}</div>
          </div>
          <div class="delivery-time line1" v-if="cart.productInfo.productPresell.presell_type === 2">
            发货时间：
            {{ cart.productInfo.productPresell.delivery_type === 1 ? '付尾款后' : '预售结束后' }}{{
              cart.productInfo.productPresell.delivery_day }}天内
          </div>
          <div class="attr line1" v-if="cart.productInfo.attrInfo">
            {{ cart.productInfo.attrInfo.suk }}
          </div>

          <div v-if="cart.productInfo.productPresellAttr" class="money font-color-red">
            {{ cart.productInfo.productPresellAttr.presell_price }}
          </div>
          <div v-else class="money font-color-red">
            ￥{{
              cart.productInfo.attrInfo
                ? cart.productInfo.attrInfo.price
                : cart.productInfo.price
            }}
          </div>
          <div class="evaluate" v-if="evaluate === 3" @click="$router.push({ path: '/goods_evaluate/' + cart.unique })">
            评价
          </div>
        </div>
        <div class="event_progress"
          v-if="cart.productInfo.productPresell.presell_type != 1 && isShowAl && orderInfo.status >= 10">
          <div class="progress_list">
            <div class="progress_name font-color"
              v-if="orderInfo.status === 10 || (orderInfo.status === 11 && orderInfo.paid === 1)">阶段一： 买家已付款</div>
            <div class="progress_name font-color" v-else-if="orderInfo.status === 11 && orderInfo.paid === 0">阶段一： 买家未付款
            </div>
            <div class="progress_price">商品定金 <span class="align_right">￥{{ orderInfo.pay_price }}</span></div>
            <div class="progress_pay">定金实付款<span class="align_right font-color">￥{{ orderInfo.pay_price }}</span></div>
          </div>
          <div class="progress_list">
            <div class="progress_name font-color">阶段二：
              <span v-if="orderInfo.status == 10 && orderInfo.presellOrder.activeStatus == 0">未开始</span>
              <span v-if="orderInfo.status == 10 && orderInfo.presellOrder.activeStatus == 1">等待买家付款</span>
              <span v-if="orderInfo.status == 11 && orderInfo.presellOrder.activeStatus == 2">交易已关闭</span>
            </div>
            <div class="progress_price">商品尾款 <span class="align_right">￥{{ orderInfo.presellOrder.pay_price }}</span>
            </div>
            <div class="progress_pay">尾款需付款<span
                class="align_right font-color">￥{{ orderInfo.presellOrder.pay_price }}</span>
            </div>
          </div>
        </div>
        <div v-if="isShow" class="event_payTime">
          <div class="event_progress">
            <div class="progress_step">
              <span class="name color_red">定金</span>
              <span class="price color_red">￥{{ (cart.productInfo.productPresellAttr.down_price *
                cart.cart_num).toFixed(2)}}</span>
            </div>
            <div class="progress_step">
              <span class="name">尾款</span>
              <span class="price">￥{{ (cart.productInfo.productPresellAttr.final_price *
                cart.cart_num).toFixed(2)}}</span>
            </div>
            <div class="progress_pay">
              {{ cart.productInfo.productPresell.final_start_time | filterDay }}开始支付尾款
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "PresellOrderGoods",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Array,
      default: () => []
    },
    orderInfo: {
      type: Object,
      default: () => { }
    }
  },
  data: function () {
    return {};
  },
  computed: {
    isShow() {
      return this.$route.path.indexOf("order/submit") === 1;
    },
    isShowAl() {
      return this.$route.path.indexOf("order/detail") === 1;
    }
  },
  mounted: function () {

  },
  methods: {}
};
</script>
<style scoped>
.goodWrapper .item .text .name .event_name {
  display: inline-block;
  color: #fff;
  font-size: .24rem;
  padding: 0 .08rem;
  line-height: .3rem;
  text-align: center;
  border-radius: 3px;
  background: #ff7f00;
}

.goodWrapper .item {
  min-height: 1.8rem;
  height: auto;
  padding-top: .3rem;
}

.event_progress {
  width: 100%;
  margin-top: .2rem;
  background: #fff;
}

.event_progress .progress_name {
  padding-left: .3rem;
  height: .6rem;
  line-height: .6rem;
  font-size: .24rem;
  font-weight: bold;
  position: relative;
}

.event_progress .progress_name::before {
  content: "";
  display: inline-block;
  width: .05rem;
  height: .34rem;
  background: #E93323;
  position: absolute;
  top: .15rem;
  left: 0;
}

.event_progress .align_right {
  float: right;
  font-weight: bold;
}

.event_progress .progress_price {
  padding: .2rem .3rem;
  color: #999999;
  font-size: .22rem;
}

.event_progress .progress_pay {
  padding: .25rem .3rem;
  background: #FFF8F7;
  font-size: .26rem;
  color: #282828;
}

.event_payTime {
  /* display: none; */
  width: 100%;
  padding: .3rem .24rem .3rem 0;
  background: #fff;
}

.event_payTime.on {
  display: block;
}

.event_progress {
  /* margin-top: .5rem; */
  position: relative;
}

.event_payTime .progress_step {
  height: .8rem;
  position: relative;
  padding-left: .6rem;
}

.event_payTime .progress_step::before {
  content: "";
  display: block;
  width: .02rem;
  height: .4rem;
  background: #e93323;
  position: absolute;
  left: .34rem;
  top: .18rem;
}

.event_payTime .progress_step .name {
  float: left;
  color: #282828;
}

.event_payTime .progress_step .name.color_red {
  color: #e93323;
}

.event_payTime .progress_step .price {
  float: right;
  color: #282828;
}

.event_payTime .progress_step .price.color_red {
  color: #e93323;
}

.event_payTime .progress_step::after {
  content: "";
  display: block;
  width: 7px;
  height: 7px;
  background: #e93323;
  border-radius: 50%;
  position: absolute;
  top: 5px;
  left: 4.1%;
}

.event_payTime .progress_step {
  height: 40px;
  position: relative;
  padding-left: 30px;
}

.event_payTime .progress_step:nth-child(2)::before {
  bottom: 32px;
  top: auto;
  background: #efefef;
}

.event_payTime .progress_pay {
  padding: 0 0 0 30px !important;
  font-size: 12px;
  color: #868686;
  margin-top: -17px;
  background: none;
}

.event_payTime .progress_step:nth-child(2)::after {
  background: #efefef;
}

.delivery-time {
  margin-top: 0.07rem;
  color: #ff7f00;
  font-size: .24rem;
}

.goodWrapper .item .text .money {
  margin-top: 0;
}
</style>
